<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmit"
        :title="$t('labels.addBankAccount')"
        :rules="rules"
        no-reset
        @close="closeOverSide">
        <hts-form-input
            v-model="formData.bankName"
            :label="$t('labels.bankName')"
            required
            name="bankName"
            prop="bankName" />

        <hts-form-input
            v-model="formData.branch"
            :label="$t('labels.branch')"
            name="branch"
            prop="branch" />

        <hts-form-input
            v-model="formData.swiftCode"
            :label="$t('labels.swiftCode')"
            name="swiftCode"
            prop="swiftCode" />

        <hts-form-input
            v-model="formData.bankAddress"
            :label="$t('labels.bankAddress')"
            name="bankAddress"
            prop="bankAddress" />

        <hts-form-input
            v-model="formData.accountNumber"
            :label="$t('labels.accountNumber')"
            required
            name="accountNumber"
            prop="accountNumber" />

        <hts-form-input
            v-model="formData.accountName"
            :label="$t('labels.accountName')"
            required
            name="accountName"
            prop="accountName" />
    </hts-drawer>
</template>
<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables', 'newData'])

const formData = ref({
  accountName: '',
  bankName: '',
  branch: '',
  swiftCode: '',
  bankAddress: '',
  accountNumber: ''
})

const rules = ref({
  bankName: 'required',
  accountNumber: 'required',
  accountName: 'required'
})

const reset = () => {
  formData.value = {
    accountName: '',
    bankName: '',
    branch: '',
    swiftCode: '',
    bankAddress: '',
    accountNumber: ''
  }
}
const handleSubmit = () => {
  const api = $url.settings.createBankAccount
  $api(api, { body: formData.value }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      emits('newData', resData.data)
      process.client && $toast().success($t('labels.addSuccess'))
      reset()
      close()
    }
  })
}
const closeOverSide = () => {
  emits('close')
}

const close = () => {
  visible.value = false
}

const open = () => {
  visible.value = true
}

defineExpose({
  open
})
</script>
